interface AboutSectionProps {
  version?: string;
  commit?: string;
}

export function AboutSection({
  version = __APP_VERSION__,
  commit = __APP_COMMIT__,
}: AboutSectionProps) {
  return (
    <section className="flex flex-col gap-3 rounded-[24px] border border-divider bg-surface-2 p-4">
      <h2 className="text-xl font-bold">About</h2>
      <p className="flex min-h-11 items-center justify-between gap-3 text-sm">
        <span>Version</span>
        <span data-testid="app-version" className="font-mono tabular-nums text-muted">
          {version} ({commit})
        </span>
      </p>
      <p className="text-sm text-muted">Your life, stitched together.</p>
    </section>
  );
}
